module.exports = __webpack_public_path__ + "static/img/xxtb6.aa825539.png";